import React from "react";
import style from "./header_searchbar.module.css";
import { useNavigate } from "react-router-dom";
import { IoIosChatboxes } from "react-icons/io";


const HeaderChatRoomButton = () => {

	const navigate = useNavigate();
	const handleClick = () => {
        
            let url = "/chats";
            navigate(url);
        }
 return (	
	<div>
	 <button className = {style.searchButton} onClick = {handleClick}><IoIosChatboxes className="icon" style={{ fontSize: "2rem" }} /></button>
	</div>
);

}


export default HeaderChatRoomButton;
